<h1 class="mb-2">
    <mdb-icon fas icon="tasks"></mdb-icon> Parametros
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2">
    <!--Card content-->
    <div class="card-body d-sm-flex p-1 justify-content-between">
        <p class="mb-0">
            <span class="grey-text">Maestros</span>
            <span> / </span>
            <span>Parametros</span>
        </p>
    </div>
</div>
<!-- Heading -->
<div class="card mb-2 detalle-cliente">
    <div class="card-body">
        <div class="row filtros-header d-flex justify-content-end" style="border-bottom: 1px solid #dee2e6;">
            <button type="button" mdbBtn color="info" (click)="showModalAgregarParametro()" size="sm" mdbWavesEffect>
                Agregar
            </button>
        </div>
        <div class="row filtros-body">
            <div class="col" style="max-width: 200px;">
                <div class="md-form">
                    <input value="" type="text" id="parametro" class="form-control" [(ngModel)]="nombreParametro" placeholder="Nombre Parametro" />
                    <label for="parametro">
                        Parametro
                    </label>
                </div>
            </div>
        </div>
        <div class="row filtros-body">
            <div class="col d-flex">
                <!-- Material inline 1 -->
                <div class="form-check form-check-inline">
                    <input type="radio" class="form-check-input" id="materialInline1" name="inlineMaterialRadiosExample"
                        [(ngModel)]="busquedaEstado" [value]="1" checked mdbInput />
                    <label class="form-check-label" for="materialInline1">Activos</label>
                </div>

                <!-- Material inline 2 -->
                <div class="form-check form-check-inline">
                    <input type="radio" class="form-check-input" id="materialInline2" name="inlineMaterialRadiosExample"
                        [(ngModel)]="busquedaEstado" [value]="2" mdbInput />
                    <label class="form-check-label" for="materialInline2">Inactivos</label>
                </div>

                <div class="form-check form-check-inline">
                    <input type="radio" class="form-check-input" id="materialInline3" name="inlineMaterialRadiosExample"
                        [(ngModel)]="busquedaEstado" [value]="3" mdbInput />
                    <label class="form-check-label" for="materialInline3">Todos</label>
                </div>
            </div>
        </div>
    </div>
    <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6;">
        <div></div>
        <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="buscar()">
            <mdb-icon fas icon="search"></mdb-icon>
            Buscar
        </button>
    </div>

    <div class="row pb-1 pt-1" id="spinnerX">
        <div class="col-md-12 d-flex justify-content-center">
            <ngx-spinner
                bdColor=""
                bdoOpacity="0.9"
                size="default"
                color="#581f87"
                type="ball-pulse-sync"
                [fullScreen]="false"
            >
            </ngx-spinner>
        </div>
    </div>

    <div class="card mb-2" *ngIf="listaParametros.length > 0" style="z-index: 1;">
        <div class="card-body">
            <table class="table table-striped table-hover table-sm align-middle"
                mdbTable mdbTableScroll scrollX="true" scrolly="true"
                maxHeight="500" striped="true" bordered="true"
                stickyHeaderBgColor="#E0E0E0"
                stickyHeaderTextColor="#212529"
                stickyHeader="true">
                <thead class="grey lighten-2">
                    <tr>
                        <th scope="col" class="text-center">Código</th>
                        <th scope="col" class="text-center" style="width: 15%px;">Parametro</th>
                        <th scope="col" class="text-center" style="width: 30%px;">Descripión</th>
                        <th scope="col" class="text-center">Tipo Parametro</th>
                        <th scope="col" class="text-center">Estado</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let parametro of listaParametros">
                        <td>{{ parametro.codigo }}</td>
                        <td>{{ parametro.nombre }}</td>
                        <td class="text-wrap">{{ parametro.descripcion }}</td>
                        <td>{{ parametro.tipo_parametro_nombre }}</td>
                        <td class="text-center">
                            <span *ngIf="parametro.activado" class="badge badge-success">Activo</span>
                            <span *ngIf="!parametro.activado" class="badge badge-danger">Inactivo</span>
                        </td>
                        <td class="text-center">
                            <button mdbBtn type="button" color="secondary" mdbWavesEffect (click)="showModalEditarParametro(parametro.codigo)" class="btn-actions-sm">
                                <mdb-icon fas icon="pen"></mdb-icon>
                            </button>
                            <button mdbBtn type="button" [color]="parametro.activado ? 'success' : 'danger'" mdbWavesEffect (click)="cambiarEstado(parametro)" class="btn-actions-sm">
                                <mdb-icon fas [icon]="parametro.activado ? 'check' : 'times'"></mdb-icon>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>

<!-- MODAL ADD Y EDIT -->
<app-agregar-editar-parametro (onGuardar)="buscar()"></app-agregar-editar-parametro>